"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interopRequire = void 0;
function interopRequire(module, name = 'default') {
    return module && module.__esModule ? module[name] : module;
}
exports.interopRequire = interopRequire;
//# sourceMappingURL=interop-require.js.map